import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=5e8ab963&scoped=true"
var script = {}
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=5e8ab963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8ab963",
  null
  
)

export default component.exports